import { render, staticRenderFns } from "./PlaylistItemTracksView.vue?vue&type=template&id=0b0f20eb&"
import script from "./PlaylistItemTracksView.vue?vue&type=script&lang=ts&"
export * from "./PlaylistItemTracksView.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistItemTracksView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports